import styled from 'styled-components'

const FieldErrorUi = styled.p`
  color: red;
  margin-top: 5px;
`

export default FieldErrorUi
